import { Dispatch, useCallback } from 'react';
import { useTheme } from 'styled-components';
import { withContent } from '@bubbletea/core';
import { IContent } from '../../../types';
import { IMainTheme } from '../../../types/theme';

import Modal from '../../UI/Modal';

import { Content, Description, Actions } from './styles';
import Title from '../../UI/Title';
import Button from '../../UI/Button';
import sendEvent from '../../../utils/sendEvent';

interface IUbiConnectModal {
  playNowModalOpen: boolean;
  setPlayNowModalOpen: Dispatch<boolean>;
  context: IContent;
}

const UbiConnectModal = ({ context, playNowModalOpen, setPlayNowModalOpen }: IUbiConnectModal) => {
  const theme = useTheme() as IMainTheme;
  const { ubiConnectModal } = context.googlesheet;
  const { title, description, openCta, downloadCta } = ubiConnectModal;

  const openUbiConnect = useCallback(() => {
    const eventDetails = {
      location: 'play on ubisoft connect',
      category: 'action',
      locationPosition: 'pop in',
      action: 'open ubisoft connect',
    };
    sendEvent(eventDetails);
    window.location.href = 'uplay://open/game/5763';
  }, []);

  const downloadUbisoftConnect = useCallback(() => {
    const eventDetails = {
      location: 'play on ubisoft connect',
      category: 'download',
      locationPosition: 'pop in',
      action: 'download ubisoft connect',
    };
    sendEvent(eventDetails);
    window.location.href = 'https://static3.cdn.ubi.com/orbit/launcher_installer/UplayInstaller.exe';
  }, []);

  const closeModal = () => {
    const eventDetails = {
      location: 'play on ubisoft connect',
      category: 'interaction',
      locationPosition: 'pop in',
      action: 'close pop in',
    };
    sendEvent(eventDetails);
    setPlayNowModalOpen(false);
  };

  return (
    <Modal
      offsetY="5vh"
      handleClose={() => closeModal()}
      isOpen={playNowModalOpen}
      animated
      backgroundColor={theme.colors['modalBackground']}
      textColor={theme.colors['text']}
    >
      <Content>
        <Title as={'h3'} textAlign={'center'}>
          {title}
        </Title>
        <Description>{description}</Description>
        <Actions>
          <Button type={'store-outlined'} handleClick={() => openUbiConnect()}>
            {openCta}
          </Button>
          <Button type={'store-outlined'} handleClick={() => downloadUbisoftConnect()}>
            {downloadCta}
          </Button>
        </Actions>
      </Content>
    </Modal>
  );
};

export default withContent(UbiConnectModal);
